var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliverable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0762 28.9155V14.3361C23.0762 13.7988 22.86 13.2841 22.4763 12.9079L17.0095 7.54845C16.6357 7.18192 16.133 6.97661 15.6094 6.97661H7.00507M23.0762 28.9155V32.0669C23.0762 33.1714 22.1807 34.0669 21.0762 34.0669H3.16992C2.06535 34.0669 1.16992 33.1714 1.16992 32.0669V8.97661C1.16992 7.87204 2.06535 6.97661 3.16992 6.97661H7.00507M23.0762 28.9155H26.6509C27.7555 28.9155 28.6509 28.02 28.6509 26.9155V8.77013C28.6509 8.22782 28.4307 7.70877 28.0407 7.33192L22.4517 1.93093C22.0787 1.57057 21.5804 1.36914 21.0618 1.36914H9.00507C7.9005 1.36914 7.00507 2.26457 7.00507 3.36914V6.97661M7.54403 21.7915H17.0095M7.54403 27.3527H17.0095",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverable);
export default __webpack_public_path__ + "static/media/deliverable.613d4fb6a11df3f4c5419f7808fb961e.svg";
export { ForwardRef as ReactComponent };